import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function useDomainClientRepository(clientId) {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/domain-clients/overview${params}`);
  };

  const loadAll = () => ApiService
    .get(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/domain-clients`);

  const add = (domainClientId) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/domain-clients/${domainClientId}`);

  const remove = (domainClientId) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/domain-clients/${domainClientId}`);

  const getClients = () => ApiService
    .get(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients`);

  return {
    load,
    loadAll,
    add,
    remove,
    getClients,
  };
}
